"use strict";
class DeveloperLawfirmController {
    constructor($scope, $window, SSHttpService, SSUtilService, SSAlertService, SSUserService, SSConfirmationService, OTPService, SSConfigService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSConfigService = SSConfigService;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        // Status filter order, the same as the Selections / ARMS pickers
        self.UNIT_STATUS_ORDER = [
            self.UNIT_STATUS_DRAFT,
            self.UNIT_STATUS_LISTED,
            self.UNIT_STATUS_RESERVED,
            self.UNIT_STATUS_SPECIAL_RESERVED,
            self.UNIT_STATUS_BOOKED,
            self.UNIT_STATUS_SOLD,
        ];

        self.PAGE_OPTIONS = [10, 25, 50, 100, 200, 400];

        self.data = SHOWSUITE.data;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.all_lawfirms = [];

        // WEB-4717: unit selection state
        self.showUnitSelection = false;
        // Assign Units waits for the project's units: opened before they
        // load, the picker would show no units and an empty saved selection.
        self.unitsLoaded = false;
        self.allUnits = [];
        self.filteredUnits = [];
        self.selectedUnitIds = {};
        self.initialUnitIds = {};
        self.selectedUnitsCount = 0;
        self.unitFilters = {};
        self.unitFilterOptions = {};
        self.show_top_filter = true;
        self.limit = 10;
        self.currentPage = 1;

        self.getLawfirms();
    }

    // API Calls

    getLawfirms() {
        const self = this;

        let url = 'sec/developer/law-firms';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (response.data && response.data.law_firms) {
                // Lawfrims list for dropdown
                self.all_lawfirms = response.data.law_firms;
            }

            // Load every unit of the current property for the unit selection
            self.getUnitStacks(self.data.property_id);

            // Get lawfirm projects and count number of units to show in respective lawfirm
            self.getLawfirmProjects();
        });
    }

    getLawfirmProjects() {
        const self = this;

        if (!self.data.property) {
            return;
        }

        let url = 'sec/developer/properties/' + self.data.property.id + '/law-firm-projects/';
        let params = {
            include: 'lawyers'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.law_firm_projects) {

                self.project_lawfirms = response.data.law_firm_projects;
                let project_lawfirm_lawyer_users = response.data.users;

                if (self.project_lawfirms) {
                    $.each(self.project_lawfirms, function (index, lawfirm) {
                        let _lawfirm = self.all_lawfirms.find(x => x.id == lawfirm.law_firm_id);
                        lawfirm.name = _lawfirm ? _lawfirm.name : '--';
                        lawfirm.selected_units = lawfirm.units ? lawfirm.units.length : 0; // Units if not assigned should be considered 0

                        if (lawfirm.lawyers) {
                            $.each(lawfirm.lawyers, function (index2, lawyer) {
                                let user = project_lawfirm_lawyer_users.find(x => x.id == lawyer.user_id);
                                lawyer.user_display_name = self.SSUserService.getDisplayName(user);
                                lawyer.user_email = user ? user.email : '--';
                                lawyer.user_status_text = self.SSUserService.getStatusText(user ? user.status : null);
                                lawyer.user_status_class = self.SSUserService.getStatusClass(user ? user.status : null);
                            });
                        }
                    });
                }
            }
        });
    }

    saveLawfirm() {
        const self = this;

        self.lawfirmErrors = {};
        if(!self.isValidLawfirmInput()){
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function(data){

                let handleResponse = function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        if(response.code && response.code == 403 && response.message){
                            // Law firm project already exist.
                            self.SSAlertService.danger("Error!", response.message);
                        }
                        else{
                           self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    let message = 'Lawfirm ' + (self.lawfirmParams.id ? 'updated' : 'added') + ' successfully.';
                    self.SSAlertService.success('Success!', message);

                    self.getLawfirms();
                };

                // Units are assigned with Assign Units. Without 'unit_ids' the
                // server links every unit when adding a firm and keeps the
                // firm's units when editing it (WEB-4716).
                let params = {
                    law_firm_id: self.lawfirmParams.law_firm_id
                };

                let url = 'sec/developer/properties/'+ self.data.property.id +'/law-firm-projects';

                loading(true);
                // 'self.lawfirmParams.id' is indicator for PUT/POST request
                if (self.lawfirmParams.id) {
                    url += '/' + self.lawfirmParams.id;
                    self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
                } else {
                    self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
                }
        });
    }

    deleteLawfirm(lawfirm_project) {
        const self = this;

        self.SSConfirmationService.getConfirmed('Confirm Delete!',
            'Are you sure you want to delete this lawfirm?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = 'sec/developer/properties/'+ lawfirm_project.property_id +'/law-firm-projects/'+ lawfirm_project.id +'/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Lawfirm removed successfully.');

                    self.getLawfirms();
                });
            }
        );
    }

    showLawfirmEditForm(lawfirm_project) {
        const self = this;

        self.lawfirmParams = {};
        self.lawfirmErrors = {};

        if (!lawfirm_project) {
            lawfirm_project = {
                id: 0,
                law_firm_id: 0,
                property_id: self.data.property.id,
                editable: 1,
            };
        }
        else{
            self.current_lawfirm_project = lawfirm_project;
        }

        let found = false;

        if (self.project_lawfirms) {
            $.each(self.project_lawfirms, function (i, _lawfirm) {
                if (lawfirm_project.id == _lawfirm.id) {
                    _lawfirm.editable = 1;
                    self.lawfirmParams = angular.copy(_lawfirm);
                    found = true;
                } else {
                    if (_lawfirm.id) {
                        _lawfirm.editable = null;
                    } else {
                        self.project_lawfirms.splice(i, 1);
                    }
                }
            });
        }

        if (!found) {
            self.project_lawfirms.push(lawfirm_project);
            self.lawfirmParams = angular.copy(lawfirm_project);
        }
    }

    hideLawfirmEditForm() {
        const self = this;

        if (!self.project_lawfirms) {
            return;
        }

        $.each(self.project_lawfirms, function (i, _lawfirm) {
            if (_lawfirm.id) {
                _lawfirm.editable = null;
            } else {
                self.project_lawfirms.splice(i, 1);
            }
        });

        self.lawfirmParams = {};
        self.lawfirmErrors = {};
    }

    isValidLawfirmInput(){
        const self = this;

        let isValid = true;

        if (!self.lawfirmParams.law_firm_id) {
            isValid = false;
            self.lawfirmErrors.name = "Lawfirm name is required.";
        }

        return isValid;
    }

    //----------   UNIT SELECTION (WEB-4717)  ----------
    //
    // The same shape as the Selections / ARMS unit pickers: every unit of the
    // project in a table, narrowed by per-column filters (the Unit No. one also
    // matches the unit name), with
    // Select all / Select filtered / Clear and a selected count. Nothing
    // reaches the server until Save, which sends exactly the selected units —
    // an empty selection unlinks every unit (WEB-4716).

    getUnitStacks(property_id) {
        const self = this;

        self.unitsLoaded = false;

        let url = 'properties/'+ property_id +'/stacks';
        let params = {
            'return_property' : true,
            'property_columns' : 'id,named_id,name,type,product_type,status,location,country,region',
            'return_stack' : true,
            'stack_columns' : 'id,named_id,name,block_no,col_index',
            'include_units' : true,
            'unit_columns' : 'id,named_id,stack_id,floor_no,floor_order,unit_no,unit_order,house_no,category,type,name,status,floor_plan'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.setUnits(response.data.property_stacks || []);
            self.unitsLoaded = true;
        });
    }

    /**
     * One row per unit, whatever its status, in natural unit-number order.
     * Labels are resolved here so filtering only compares strings.
     */
    setUnits(stacks) {
        const self = this;

        let units = [];
        $.each(stacks, function (i, stack) {
            $.each(stack.units || [], function (j, unit) {
                if (!unit.id) {
                    return;
                }
                units.push({
                    id: unit.id,
                    unit_no: self.SSUtilService.getFullUnitNumber(unit) || '',
                    name: (unit.name || '').trim(),
                    block_no: (stack.block_no || '').toString().trim(),
                    floor_no: (unit.floor_no || '').toString().trim(),
                    unit_type: (self.SSConfigService.getUnitTypeName(unit.type) || '').trim(),
                    floor_plan: (unit.floor_plan || '').toString().trim(),
                    status: unit.status,
                    status_name: self.SSConfigService.getUnitStatusName(unit.status) || '--',
                });
            });
        });
        units.sort((a, b) => self.naturalCompare(a.unit_no, b.unit_no));

        self.allUnits = units;
        self.unitFilterOptions = {
            block_no: self.distinctValues('block_no'),
            unit_type: self.distinctValues('unit_type'),
            floor_plan: self.distinctValues('floor_plan'),
            status: self.UNIT_STATUS_ORDER
                .filter(status => units.some(unit => unit.status == status))
                .map(status => ({id: status, name: self.SSConfigService.getUnitStatusName(status)})),
        };
        self.applyUnitFilters();
    }

    naturalCompare(a, b) {
        return (a || '').localeCompare(b || '', undefined, {numeric: true, sensitivity: 'base'});
    }

    /** The distinct non-empty values of a column, for its filter dropdown. */
    distinctValues(key) {
        const self = this;

        let values = [];
        $.each(self.allUnits, function (i, unit) {
            if (unit[key] && values.indexOf(unit[key]) === -1) {
                values.push(unit[key]);
            }
        });
        return values.sort((a, b) => self.naturalCompare(a, b));
    }

    /** Any filter on — this switches the bar to "Select filtered" / "Clear filtered". */
    unitFiltersActive() {
        const self = this;

        let f = self.unitFilters;
        return !!(f.block_no || f.unit_type || f.floor_plan ||
            (f.status !== undefined && f.status !== null && f.status !== '') ||
            (f.floor_no || '').trim() || (f.search || '').trim());
    }

    /**
     * Dropdowns match exactly; Floor matches the floor number exactly; search
     * matches part of the unit number or name, '#' optional. All combine with AND.
     */
    applyUnitFilters() {
        const self = this;

        let f = self.unitFilters;
        let floor = (f.floor_no || '').trim().toLowerCase();
        let search = (f.search || '').trim().toLowerCase().replace(/#/g, '');
        let hasStatus = f.status !== undefined && f.status !== null && f.status !== '';

        self.filteredUnits = self.allUnits.filter(function (unit) {
            return (!f.block_no || unit.block_no === f.block_no) &&
                (!floor || unit.floor_no.toLowerCase() === floor) &&
                (!f.unit_type || unit.unit_type === f.unit_type) &&
                (!f.floor_plan || unit.floor_plan === f.floor_plan) &&
                (!hasStatus || unit.status == f.status) &&
                (!search ||
                    unit.unit_no.toLowerCase().replace(/#/g, '').indexOf(search) !== -1 ||
                    unit.name.toLowerCase().indexOf(search) !== -1);
        });
        self.currentPage = 1;
    }

    clearUnitFilters() {
        const self = this;

        self.unitFilters = {};
        self.applyUnitFilters();
    }

    /** Opens the unit selection on a copy of the law firm's saved units. */
    openUnitSelection(lawfirm_project) {
        const self = this;

        if (!self.unitsLoaded) {
            return;
        }

        self.current_lawfirm_project = lawfirm_project;

        // Saved ids that are no longer in the project drop out without counting as a change
        let projectIds = {};
        $.each(self.allUnits, function (i, unit) {
            projectIds[unit.id] = true;
        });

        self.initialUnitIds = {};
        $.each(lawfirm_project.units || [], function (i, unit_id) {
            if (projectIds[unit_id]) {
                self.initialUnitIds[unit_id] = true;
            }
        });
        self.selectedUnitIds = angular.copy(self.initialUnitIds);
        self.updateSelectedCount();

        self.clearUnitFilters();
        self.showUnitSelection = true;
    }

    updateSelectedCount() {
        const self = this;

        self.selectedUnitsCount = Object.keys(self.selectedUnitIds).length;
    }

    isUnitSelected(unit) {
        return !!this.selectedUnitIds[unit.id];
    }

    toggleUnit(unit) {
        const self = this;

        if (self.selectedUnitIds[unit.id]) {
            delete self.selectedUnitIds[unit.id];
        } else {
            self.selectedUnitIds[unit.id] = true;
        }
        self.updateSelectedCount();
    }

    /** Header checkbox: all shown rows selected. */
    allShownSelected() {
        const self = this;

        return self.filteredUnits.length > 0 &&
            self.filteredUnits.every(unit => self.selectedUnitIds[unit.id]);
    }

    /** Header checkbox: clears every shown row when all are selected, otherwise selects them all. */
    toggleShownUnits() {
        const self = this;

        if (self.allShownSelected()) {
            self.clearUnits(self.filteredUnits);
        } else {
            self.selectUnits(self.filteredUnits);
        }
    }

    /** "Select all (n)", or "Select filtered (n)" while a filter is on. */
    selectAllOrFiltered() {
        const self = this;

        self.selectUnits(self.unitFiltersActive() ? self.filteredUnits : self.allUnits);
    }

    /** "Clear", or "Clear filtered" while a filter is on. */
    clearAllOrFiltered() {
        const self = this;

        if (self.unitFiltersActive()) {
            self.clearUnits(self.filteredUnits);
        } else {
            self.selectedUnitIds = {};
            self.updateSelectedCount();
        }
    }

    selectUnits(units) {
        const self = this;

        $.each(units, function (i, unit) {
            self.selectedUnitIds[unit.id] = true;
        });
        self.updateSelectedCount();
    }

    clearUnits(units) {
        const self = this;

        $.each(units, function (i, unit) {
            delete self.selectedUnitIds[unit.id];
        });
        self.updateSelectedCount();
    }

    isUnitSelectionDirty() {
        const self = this;

        let initial = Object.keys(self.initialUnitIds);
        let selected = Object.keys(self.selectedUnitIds);
        return initial.length !== selected.length ||
            selected.some(id => !self.initialUnitIds[id]);
    }

    /** Cancel: confirm when the selection changed, otherwise just leave. */
    closeUnitSelection() {
        const self = this;

        if (!self.isUnitSelectionDirty()) {
            self.showUnitSelection = false;
            return;
        }

        self.SSConfirmationService.getConfirmed('Discard changes?',
            'Your unit selection has not been saved.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.showUnitSelection = false;
            }
        );
    }

    /** Save. An empty selection unlinks every unit, so it is confirmed first. */
    saveSelectedUnits() {
        const self = this;

        if (self.selectedUnitsCount > 0) {
            self.submitSelectedUnits();
            return;
        }

        self.SSConfirmationService.getConfirmed('Unlink all units?',
            'No units are selected. Saving will unlink every unit from this law firm.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.submitSelectedUnits();
            }
        );
    }

    /**
     * PUTs exactly the selected units. 'unit_ids' is always sent: an empty
     * value is how "no units" reaches the server (WEB-4716), while a missing
     * one means "keep the current units".
     */
    submitSelectedUnits() {
        const self = this;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function(data){

                let unit_ids = Object.keys(self.selectedUnitIds)
                    .map(id => parseInt(id, 10))
                    .sort((a, b) => a - b);

                let params = {
                    law_firm_id: self.current_lawfirm_project.law_firm_id,
                    unit_ids: unit_ids.join(',')
                };

                let url = 'sec/developer/properties/'+ self.data.property.id +'/law-firm-projects/'+ self.current_lawfirm_project.id;

                loading(true);
                self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        if (response.message) {
                            self.SSAlertService.danger('Error!', response.message);
                        } else {
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    let message = unit_ids.length
                        ? unit_ids.length + ' unit(s) assigned to ' + self.current_lawfirm_project.name + ' successfully.'
                        : 'All units unlinked from ' + self.current_lawfirm_project.name + ' successfully.';
                    self.SSAlertService.success('Success!', message);

                    self.showUnitSelection = false;
                    self.getLawfirmProjects();
                });
        });
    }

    //---------------------------------

}

DeveloperLawfirmController.$inject = ['$scope', '$window', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService', 'SSConfirmationService', 'OTPService', 'SSConfigService'];
app.controller('DeveloperLawfirmController', DeveloperLawfirmController);
